import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import SingleSlider from '../widget/SingleSlider';
import Tooltip from '../widget/Tooltip';

import i18n from '../../i18n';
import { Icon } from '@homeexchange/design';

const EditGuestPointsInput = ({ value, onChange, save, sliderMax }) => {
    const [btnActive, setBtnActive] = useState(true);

    const handleOnSlide = useCallback((val) => {
        const event = {
            target: { value: parseInt(val, 10) }
        };
        onChange(event);
    }, []);

    const handleOnchange = useCallback(() => {
        setBtnActive(false);
    }, []);

    const handleSave = useCallback(() => {
        save();
        setBtnActive(true);
    }, []);

    return (
        <div className="edit-guestpoint-container">
            <div className="slider-container">
                <SingleSlider
                    value={value}
                    min={0}
                    max={sliderMax}
                    onChange={handleOnchange}
                    onSlide={handleOnSlide}
                />
            </div>
            <div className="actions-container">
                <div className="label-text">
                    <Tooltip placement="bottom" title={i18n.t('exchange:edit.guestpoint.tooltip')}>
                        <Icon name="QuestionCircleOutline" />
                    </Tooltip>
                    {i18n.t('exchange:edit.guestpoint.update_label')}
                </div>
                <button onClick={handleSave} disabled={btnActive}>
                    {i18n.t('common:update')}
                </button>
            </div>
        </div>
    );
};

EditGuestPointsInput.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.number,
    save: PropTypes.func,
    sliderMax: PropTypes.number.isRequired
};

export default EditGuestPointsInput;
